import { useState } from "react";
import { accountService } from "@miplatform/api";
import { CONTACT_TYPES, HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState } from "@miplatform/hooks";

export const useContactsSearchViewModel = ({
  accountIds,
  referenceIds,
  onRefresh,
  selectedContacts,
  setSelectedContacts,
}) => {
  const stateManager = useComponentState();
  const isLoading = stateManager.isBusy();
  const [contacts, setContacts] = useState([]);
  const [activeCategories, setActiveCategories] = useState([]);
  const [primaryRelationshipTypes, setPrimaryRelationshipTypes] = useState(
    new Set()
  );

  const getContacts = () => {
    stateManager.run(async () => {
      const response = await accountService.contacts.getAll({
        sort: "firstName asc",
        ...(accountIds && {
          filters: {
            or: [{ accountId: { in: accountIds } }, { accountId: null }],
          },
        }),
      });
      if (response.status === HTTP_STATUSES.OK) {
        const newContacts = [];
        const newSelectedContacts = [];
        const selectedContactsMap = new Map(
          selectedContacts.map((c) => [c.id, c])
        );
        response.data.forEach((contact) => {
          const foundContact = selectedContactsMap.get(contact.id);
          if (foundContact) {
            newSelectedContacts.push({
              ...contact,
              dependentType: foundContact.dependentType,
              label: foundContact.label,
            });
          } else {
            newContacts.push(contact);
          }
        });

        setContacts(newContacts);
        setSelectedContacts(newSelectedContacts);
      }
    });
  };

  const getContactCategoriesOptions = () => {
    stateManager.run(async () => {
      const response = await accountService.contactCategories.getByType({
        type: CONTACT_TYPES.HOMES,
      });
      if (response.status === HTTP_STATUSES.OK) {
        const activeCategories = response.data.filter((e) => e.isActive);

        setActiveCategories(activeCategories);
        setPrimaryRelationshipTypes(
          new Set(
            activeCategories
              .filter(({ canBePrimary }) => canBePrimary)
              .map(({ label }) => label)
          )
        );
      }
    });
  };

  const addContactRelationship = async (contact) =>
    stateManager.run(async () => {
      const response = await accountService.contacts.createContactRelationship({
        id: contact.id,
        data: {
          accountId: contact.accountId,
          label: contact.dependentType,
          isPrimary: contact.isPrimary,
          RelatedReferenceId: referenceIds[CONTACT_TYPES.HOMES],
        },
        toastMessageConfig: {
          success: {
            text: ` Contact relationship created successfully.`,
          },
          failure: {
            text: `Failed to create contact relationship.`,
          },
        },
      });
      if (response.status === HTTP_STATUSES.OK) {
        onRefresh?.(contact);
        return true;
      }
      return false;
    });

  return {
    isLoading,
    contacts,
    activeCategories,
    primaryRelationshipTypes,
    getContacts,
    getContactCategoriesOptions,
    addContactRelationship,
  };
};
